import React from 'react';
import { Button } from '../ui/Button';

export interface StickyDockProps {
  primaryAction?: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    icon?: React.ReactNode;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    variant?: 'outline' | 'ghost';
  };
  children?: React.ReactNode;
  className?: string;
}

export const StickyDock: React.FC<StickyDockProps> = ({
  primaryAction,
  secondaryAction,
  children,
  className = '',
}) => {
  if (!primaryAction && !secondaryAction && !children) {
    return null;
  }

  return (
    <div className={`sticky-dock ${className}`} role="region" aria-label="Ações principais">
      {children || (
        <div className="flex items-center gap-3 w-full max-w-screen-xl mx-auto">
          {secondaryAction && (
            <Button
              variant={secondaryAction.variant || 'outline'}
              onClick={secondaryAction.onClick}
              disabled={secondaryAction.disabled}
              className="flex-1"
            >
              {secondaryAction.label}
            </Button>
          )}
          <Button
            variant="primary"
            fullWidth={!secondaryAction}
            onClick={primaryAction?.onClick}
            disabled={primaryAction?.disabled}
            isLoading={primaryAction?.isLoading}
            leftIcon={primaryAction?.icon}
          >
            {primaryAction?.label}
          </Button>
        </div>
      )}
    </div>
  );
};